import { ArticleHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingHeaderBrokerBlock.css';
import percentIcon from './assets/percent.svg';

interface INewbuildingHeaderBrokerBlockProps {
  rewardTariffsLink: string;
}

export const NewbuildingHeaderBrokerBlock: React.FC<INewbuildingHeaderBrokerBlockProps> = ({ rewardTariffsLink }) => {
  return (
    <div className={styles['container']} data-testid="NewbuildingHeaderBrokerBlock">
      <img className={styles['image']} src={percentIcon} />
      <div className={styles['info']}>
        <div className={styles['title']}>
          <ArticleHeading4 color="black_100">Зарабатывайте с Циан </ArticleHeading4>
        </div>
        <UIText2 whiteSpace="pre-line" color="current_color">
          Заработать на квартирах в этом ЖК
        </UIText2>
        <a
          className={styles['link']}
          href={rewardTariffsLink}
          data-testid="NewbuildingHeaderBrokerBlockLink"
          target="_blank"
          rel="noopener noreferrer"
        >
          Сколько можно заработать
        </a>
      </div>
    </div>
  );
};
